<div class="layout-auto-1">
  <div *ngIf="isLoading" class="splash loading">
    <i class="fas fa-spinner fa-spin"></i>
    <p>{{getGlobal('Loading')}}</p>
  </div>
  <div *ngIf="!isLoading && gdvActions.length === 0" class="splash empty">
    <p>{{getTranslation('Es wurden keine Daten gefunden!')}}</p>
  </div>

  <div class="content" *ngIf="gdvActions.length > 0 && !isLoading">
    <div *ngFor="let action of gdvActions"
         class="list-row app-cursor-pointer"
         [style.background-color]="action.isExecuted && (action.quittungType === '04' || action.quittungType === '15') ? '#d4edda' : (action.quittungType === '04' || action.quittungType === '15') ? '#fff3cd' : ''"
         [style.border-left]="(action.quittungType === '04' || action.quittungType === '15') ? (action.isExecuted ? '4px solid #28a745' : '4px solid #ffc107') : ''"
         [style.padding]="'1rem'"
         [style.margin-bottom]="'0.5rem'"
         (click)="openAction(action)">
      <div class="grid-auto-1" style="padding: 0">
        <div class="list-avatar nobackground">
          <i class="far fa-fw fa-2x"
             [class.fa-receipt]="!action.isExecuted && !action.isLoading"
             [class.fa-check-circle]="action.isExecuted"
             [class.fa-spinner]="action.isLoading"
             [class.fa-spin]="action.isLoading"></i>
        </div>
        <div class="layout-auto-1">
          <div class="grid-1-auto">
            <div>
              <strong>{{action.title}}</strong>
            </div>
            <div class="spawn list-metadata">
              {{ActionStatusText(action)}}
            </div>
          </div>
          <div class="list-metadata" style="margin-top: 0.25rem">
            {{action.description}}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
